{
    "ZdpCi2uWw_V4XqNJDJTBv": {
        "tag": "spawngood",
        "key": "ZdpCi2uWw_V4XqNJDJTBv",
        "position": {
            "x": 3,
            "y": 6,
            "z": 1
        }
    }
}